import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({
  switchBase: {
    height: 30,
    color: theme.ToggleDisableIconColor,
    "&$colorChecked": {
      color: theme.ToggleIconColor,
      "& + $colorBar": {
        backgroundColor: theme.ToggleIconColor
      }
    }
  },
  colorBar: {
    backgroundColor: theme.ToggleDisableIconColor
  },
  colorChecked: {}
});

const ToggleRenderer = props => {
  const { classes, context } = props;
  const { disabled, tooltipTitle="" } = context || {
    disabled: false,
    tooltipTitle: ""
  };
  const { field } = props.colDef || {};
  return (
    <Tooltip title={tooltipTitle}>
      <div>
        <Switch
          checked={Boolean(props.value)}
          disabled={disabled}
          onChange={(event, checked) => {
            props &&
              props.node &&
              props.node.setDataValue &&
              props.node.setDataValue(field, checked);
            props.onChange && props.onChange(event, checked);
          }}
          classes={{
            switchBase: classes.switchBase,
            checked: classes.colorChecked,
            bar: classes.colorBar
          }}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(ToggleRenderer);
